import EmptyStateComp from "../../../viewpages/newpages/EmptyStateComp";
import DictationRenderer from "../../contentReaderMarkdown/dictationRenderer";
import emptynotes from "../images/emptynotes.svg";

const DictationComp = ({ dictation, dictationLoading }) => {
   return (
      <div>
         {dictationLoading ? (
            <div
               style={{ width: "100%", height: "40vh" }}
               class="d-flex justify-content-center align-items-center text-center"
            >
               <div class="d-flex justify-content-center">
                  <div
                     style={{ width: "8rem", height: "8rem" }}
                     className="spinner-border  loader-color text-center"
                  ></div>
               </div>
            </div>
         ) : dictation === null || dictation === "" ? (
            <div style={{ height: "45vh" }} className="d-flex justify-content-center text-center justify-item-center">
               <EmptyStateComp
                  src={emptynotes}
                  patientList={true}
                  description="No dictation available"
                  className="margin-viewd-screen"
               />
            </div>
         ) : (
            <DictationRenderer content={dictation} />
         )}
      </div>
   );
};

export default DictationComp;
